// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c2813d4124c7c605","9990":"6a6faf8df37eec12"}[chunkId] + ".css";
};